import React from "react";
import styled from "@emotion/styled";
import "../styles/solidHeader.scss";

const HeaderImageContainer = styled.div`
  background-image: ${props =>
    props.categorySaleImage
      ? `url(${encodeURI(props.categorySaleImage)}) !important`
      : `url(https://cdn.cardcash.com/website/ui/elements/categories/${props.bgImage}) !important`};
  @media (max-width: 767px) {
    background-image: ${props =>
      props.categorySaleImage
        ? ``
        : `url(https://cdn.cardcash.com/website/ui/elements/categories/Tablet/${props.bgImage}) !important`};
  }
  @media (max-width: 500px) {
    background-image: ${props =>
      props.categorySaleImage
        ? ``
        : `url(https://cdn.cardcash.com/website/ui/elements/categories/mobile/${props.bgImage}) !important`};
  }
`;

const SolidHeader = ({
  children,
  styles,
  setClassName,
  headerImage,
  categorySaleImage
}) => {
  const categoryStyle = headerImage
    ? {
        backgroundImage: `url(https://cdn.cardcash.com/website/ui/elements/categories/${headerImage}`
      }
    : {};
  return (
    <div className={`${setClassName}`}>
      <div
        className={`solid-header-inner-div orange-caret ${
          categorySaleImage ? "" : "category-purple"
        }`}
      />
      <HeaderImageContainer
        bgImage={headerImage}
        categorySaleImage={categorySaleImage}
        style={{
          ...styles,
          ...categoryStyle
        }}
        className={`${setClassName} divHeader-solid-header ${
          categorySaleImage ? "category-sale-image" : "regular-image"
        }`}
      >
        <div>{children}</div>
      </HeaderImageContainer>
    </div>
  );
};

export default SolidHeader;
